import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import LeftArrow from '../../../../../asset/svg/leftArrow.svg'
import { CHECKLIST_EDIT_SCHEDULE_PATH } from '../../../../../utils/Constants';
import '../../../../../scss/pages/Attendance/Component/Checklist/RescheduleHistory/RescheduleHistory.scss';
import NoRescheduleHistory from '../../../../../asset/svg/NoRescheduleHistory.svg'
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { GET_RESCHEDULE_HISTORY } from '../../../../../sagas/type';

function RescheduleHistory() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { getReScheduleHistory } = useSelector(mapStateToProps)
    const { editData, filterState } = location?.state;
    const [historyData, setHistoryData] = useState([]);

    useEffect(() => {
        if (getReScheduleHistory && getReScheduleHistory?.length) {
            setHistoryData(getReScheduleHistory)
        }
    }, [getReScheduleHistory])
    const handleBack = () => {
        navigate(CHECKLIST_EDIT_SCHEDULE_PATH, { state: { editData: editData, filterState: filterState } })
    }

    const handleClickOkayIt = () => {
        navigate(CHECKLIST_EDIT_SCHEDULE_PATH, { state: { editData: editData, filterState: filterState } })
    }
    useEffect(() => {
        dispatch({
            type: GET_RESCHEDULE_HISTORY,
            payload: { scheduleId: editData?.id }
        })
    }, [])
    return (
        <div className='RescheduleHistory-Container' >
            <div className='RescheduleHistory-Container_header'>
                <div className='RescheduleHistory-Container_header_head-height'>
                    <img className='RescheduleHistory-Container_header_head-height_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='RescheduleHistory-Container_header_head-height_content'>Reschedule History</span>
                </div>
            </div>
            {historyData?.length > 0 ? <div>
                {historyData?.map((item) => {
                    return (
                        <div key={item?.id} className='RescheduleHistory-Container_Card-Parent'>
                            <div className="RescheduleHistory-Container_Card-Parent_Card">
                                <div>
                                    <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: " 0 0 7px 0 " }}>Requested Date</Typography>
                                    <Typography sx={{ color: "#FFF", fontWeight: 600, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize', marginTop: "2px", }} value="name">{moment(item?.createdAt).format('DD / MM / yyyy')}</Typography>
                                </div>
                                <div>
                                    <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: " 0 0 7px 0 " }}>Past Schedule Date</Typography>
                                    <Typography sx={{ color: "#FFF", fontWeight: 600, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize', marginTop: "2px", }} value="name">{moment(item?.startDate).format('DD / MM / yyyy')}</Typography>
                                </div>
                            </div>
                            <div className="RescheduleHistory-Container_Card-Parent_Reason">
                                <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: " 0 0 7px 0 " }}>Reason</Typography>
                                <Typography sx={{ color: "#FFF", fontWeight: 600, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize', marginTop: "2px", }} value="name">{item?.reason}</Typography>
                            </div>
                        </div>
                    )
                })}
            </div> :
                <div className="RescheduleHistory-Container_historyContainer">
                    <div className="RescheduleHistory-Container_historyContainer_imageContainer">
                        <img src={NoRescheduleHistory} alt="" />
                    </div>
                    <div className="RescheduleHistory-Container_historyContainer_historyText">
                        <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='rgba(255,255,255,0.8)'>
                            No History Found
                        </Typography>
                    </div>
                </div>

            }
            <div className='RescheduleHistory-Container_Download-button'>
                <div className='RescheduleHistory-Container_Download-button_btn-bottom'>
                    <div className='RescheduleHistory-Container_Download-button_btn-bottom_okbutton-container'>
                        <button id='downloadBtn' className='RescheduleHistory-Container_Download-button_btn-bottom_okbutton-container_active-button' onClick={handleClickOkayIt}>Okay, Got it</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        getReScheduleHistory: state?.checklist?.getReScheduleHistory,
    }
}

export default RescheduleHistory